import * as React from 'react';
import { useState, useRef, useEffect } from 'react';
import moment from "moment";
import { post, get } from "jquery";
import { useHistory } from 'react-router-dom';

import Button from '../../components/forms/button';
import ContentTitle from '../../components/common/container/title';
import InlineInput from '../../components/forms/inlineinput';
import InlineData from '../../components/forms/inlinedata';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import IRC0111_2Table from "./irc0111_2-table";
import { isMobile } from 'react-device-detect';

import Translate from '../../components/common/translate';
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
import ja from "date-fns/locale/ja";

var jaLocale = {
    ...ja,
    options: {
        weekStartsOn: 0, firstWeekContainsDate: 1
    }
}
registerLocale('ja', jaLocale);
const getTranslateValue = Utils.getTranslateValue;

const API = {
    GETBILLINGDETAILSINFO: window.domainDir + "api/Billing/GetBillingDetailsInfo",
    VALIDATEIRAI: window.domainDir + "api/Billing/ValidateIrai"
};

const URLPath = {
    IRC0101: "/Billing/Search",
}

const SESSION_KEYS = {
    IRAINO: 'bbmedical_iraino',
    SHOWPASSWORD: 'bbmedical_showpassword'
}

const IRC0111_2_Master = (props) => {
    let translate = useRef(null);
    let history = useHistory();

    const [currentPage, setPageNo] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [isFetching, setLoadingState] = useState(false);
    const [isFacilityLoaded, setFacilityLoaded] = useState(false);

    const [translateSuccess, setTranslateSuccess] = useState(false);

    const [iraiNo, setIraiNo] = useState(null);
    const [deliveredItems, setDeliveredItems] = useState([]);
    const [facility, setFacility] = useState({
        IraiStatus: 0,
        PostalCode: "",
        Address: "",
        FacilityName: "",
        KanjiName: "",
        KanaName: "",
        DepartmentName: "",
        Phone: "",
        Fax: "",
        Email: "",
        DateShipped: "",
        InvoiceNumber: "",
        DeliveryCompany: "",
        HasShuka: false
    });

    useEffect(() => {
        $("#loading").fadeIn();
        initFromSession();
        $("#loading").fadeOut();
    }, []);

    function initFromSession() {
        const rawNo = sessionStorage.getItem(SESSION_KEYS.IRAINO);
        const rawPw = sessionStorage.getItem(SESSION_KEYS.SHOWPASSWORD);

        const rowsFromSession = sessionStorage.getItem('DELIVERED_ITEMS');
        const facilityFromSession = sessionStorage.getItem('FACILITY_INFO');

        setIraiNo(Number(rawNo));

        if (rowsFromSession) {
            setDeliveredItems(JSON.parse(rowsFromSession));
        }

        if (facilityFromSession) {
            setFacility(JSON.parse(facilityFromSession));
        }
        
        sessionStorage.removeItem(SESSION_KEYS.IRAINO);
        sessionStorage.removeItem(SESSION_KEYS.SHOWPASSWORD);
        sessionStorage.removeItem('DELIVERED_ITEMS');
        sessionStorage.removeItem('FACILITY_INFO');
    }


    function renderSearchPanel() {
        return (
            <div>
                {renderFacilityInfo()}
                {renderOrdererInfo()}
            </div>
        );
    }

    function handleRedirect(path) {
        if (typeof path === 'string' || path instanceof String) {
            history.push(path);
        }
    }

    function renderFacilityInfo() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.facilityinfo")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.postalcode")}
                    name="postalcode"
                    value={facility.PostalCode}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.address")}
                    name="address"
                    value={facility.Address}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.facilityname")}
                    name="facilityname"
                    value={facility.FacilityName}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.phonenumber")}
                    name="phonenumber"
                    value={facility.Phone}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.fax")}
                    name="fax"
                    value={facility.Fax}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
            </div>
        );
    }

    function renderOrdererInfo() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.ordererinfo")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.kanjiname")}
                    name="kanjiname"
                    value={facility.KanjiName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.kananame")}
                    name="kananame"
                    value={facility.KanaName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.email")}
                    name="email"
                    value={facility.Email}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.departmentname")}
                    name="departmentname"
                    value={facility.DepartmentName}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
            </div>
        );
    }

    function renderDeliveredMaterialsTable() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.deliveredmaterials")}</legend>
                <IRC0111_2Table
                    data={deliveredItems}
                    pageNo={currentPage}
                    sizePerPage={sizePerPage}
                    isFetching={isFetching}
                    translate={translate}
                    setPageNo={setPageNo.bind(this)}
                    setSizePerPage={setSizePerPage.bind(this)}
                    getTranslateValue={getTranslateValue.bind(this)}
                />
            </div>
        );
    }

    function renderActionButtons() {
        return (
            <div>
                <div className="row form-group">
                    {/* Show Cancel Billing button only when there is no shuka record (first box red / other boxes hidden) */}
                    {!facility.HasShuka && (
                        <div className="col-sm-12" style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ display: 'inline-block', padding: 0 }}>
                                <Button color="Success" className="flex-grow-0" label={getTranslateValue(translate.current, "views.irc0111.returntolist")} onClick={handleRedirect.bind(this, URLPath.IRC0101)} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    function renderInfoMessage() {
        return (
            <div>
                <div className="row" >
                    <div className="info-msg-content" style={{ margin: "15px" }}>
                        <label>{ getTranslateValue(translate.current, "views.irc0111.message1") }</label><br />
                        <label>{ getTranslateValue(translate.current, "views.irc0111.message2") }</label><br />
                        <label style={{ fontSize: "20px", fontWeight: "bold" }}>{`${ getTranslateValue(translate.current, "views.irc0111.message3")} ${iraiNo}`}</label><br />
                    </div>
                </div>
            </div>
        );
    }
    
    return (
        <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
            <ContentTitle active="#IRC0111" title={getTranslateValue(translate.current, "views.irc0111.confirmbillingdetails")} />
            {/* {renderSteps()} */}
            <div className="main-content">
                <div className="container-fluid" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    {renderInfoMessage()}
                    {renderSearchPanel()}
                    {renderDeliveredMaterialsTable()}
                    <div style={{ height: 25 }} />
                    {renderActionButtons()}
                </div>
            </div>
        </Translate>
    )
}

export default IRC0111_2_Master;


// WEBPACK FOOTER //
// ./view/IRC0111_2/irc0111_2.jsx